define.alias("ember-composable-helpers/helpers/intersect", "media/helpers/intersect");